import React, { useEffect } from 'react';
import { confirmStripePaymentIntent, createStripePaymentIntent } from '../../queries/stripe.graphql.js';
import { setQuotePaymentMethodStripe } from '@crossroads/shop-state/quote';
import { STRIPE_PAYMENT_METHOD_CODE, StripePaymentProvider } from '@crossroads/stripe';
import { useSendMessage } from 'crustate/react';
import { StripeView } from './StripeView/index.js';

/* eslint-disable react-hooks/exhaustive-deps */
var StripeCheckoutContainer = _ref => {
  var open = _ref.open,
      setOpen = _ref.setOpen,
      enableDiscountCode = _ref.enableDiscountCode,
      formatPrice = _ref.formatPrice,
      formatPoints = _ref.formatPoints,
      client = _ref.client,
      storeInfo = _ref.storeInfo,
      quote = _ref.quote,
      quoteData = _ref.quoteData,
      helpdesk = _ref.helpdesk,
      checkoutRoute = _ref.checkoutRoute,
      checkoutContent = _ref.checkoutContent,
      customerQuery = _ref.customerQuery,
      setQuoteDiscountCode = _ref.setQuoteDiscountCode,
      removeQuoteDiscountCode = _ref.removeQuoteDiscountCode,
      paymentMethodsCards = _ref.paymentMethodsCards,
      agreement = _ref.agreement,
      browserProcess = _ref.browserProcess;
  var sendMessage = useSendMessage(); // Set Stripe as payment method if grandTotal > 0

  useEffect(() => {
    if (quote && quote.grandTotal.incVat > 0) {
      var payment = quote.payment;
      var paymentCode = payment && payment.code; // Set payment method to stripe if selected

      if (paymentCode !== STRIPE_PAYMENT_METHOD_CODE) {
        sendMessage(setQuotePaymentMethodStripe());
      }
    }
  }, [quote]);

  if (quoteData.state === "LOADING" || !quote) {
    return null;
  }

  var stripeKey = quote.payment && quote.payment.code === STRIPE_PAYMENT_METHOD_CODE ? quote.payment.publishableKey : "";
  var amountToPay = quote.grandTotal.incVat;
  return /*#__PURE__*/React.createElement(StripePaymentProvider, {
    client: client,
    amountToPay: amountToPay,
    stripeKey: stripeKey,
    quote: quote,
    confirmStripePaymentIntentQuery: confirmStripePaymentIntent,
    createStripePaymentIntentQuery: createStripePaymentIntent,
    storeInfo: storeInfo.info
  }, /*#__PURE__*/React.createElement(StripeView, {
    open: open,
    setOpen: setOpen,
    enableDiscountCode: enableDiscountCode,
    formatPrice: formatPrice,
    formatPoints: formatPoints,
    client: client,
    quote: quote,
    quoteData: quoteData,
    helpdesk: helpdesk,
    checkoutRoute: checkoutRoute,
    checkoutContent: checkoutContent,
    customerQuery: customerQuery,
    setQuoteDiscountCode: setQuoteDiscountCode,
    removeQuoteDiscountCode: removeQuoteDiscountCode,
    paymentMethodsCards: paymentMethodsCards,
    agreement: agreement,
    browserProcess: browserProcess
  }));
};

export { StripeCheckoutContainer };
//# sourceMappingURL=index.js.map
